import React, { useCallback } from 'react'
import {
  CopyComponentStyle,
  DownloadComponentStyle,
  InfoDealStatusComponentStyle
} from '../TradeBlotter.style'
import {
  leToolRoutes,
  MODAL_TITLE,
  MODAL_TYPE,
  routes,
  STAGING_STATUS,
  TRADE_BLOTTER_STATUS
} from '../../../utils/constants'
import { cleanEmptyField, copyId, downlandExcelTrades } from '../../../helper'
import MenuItem from '../components/MenuItem/MenuItem'
import { setModal } from '../../../redux/slices/Modal/modalSlice'
import axios from 'axios'
import { handelNotifications } from '../../../redux/slices/Notification/notificationSlice'
import { webSocketWorkerEvent } from '../../../services'
import dayjs from 'dayjs'

const useTradeBlotterAgGridSetting = ({
  dealTradesGroup,
  setDealTradesGroup,
  dealsGiveUpGroup,
  setDealsGiveUpGroup,
  tradesGroup,
  tradesConversion,
  setTradesConversion,
  setTradesGroup,
  dealsGroup,
  setDealsGroup,
  setDealsNotSentToPb,
  dealsNotSentToPb,
  cleanCheckBoxState,
  unAllocatedDeals,
  setUnAllocatedDeals,
  gridRef,
  selected,
  setExpandsRow,
  setSelected,
  setPage,
  tradesGiveUp,
  setTradesGiveUp,
  filters,
  setFilters,
  dispatch,
  token,
  selectedAllDeal,
  setSelectedAllDeal,
  tradeBlotterResponse,
  bloombergRefresh,
  setBloombergRefresh,
  gridScrollHight,
  lock,
  setLock,
  tradeBlotterDataAgGrid,
  tradeBlotterPendingAgGrid
}) => {
  const getRowId = useCallback(function (params) {
    if (Array.isArray(params.data.children)) {
      return String(params.data.id).concat('D')
    }
    return String(params.data.id).concat('T')
  }, [])

  const skeltonLoader = useCallback(() => {
    const dataSource = { getRows }
    tradeBlotterDataAgGrid.current = [{ isSkelton: true }]
    gridRef.current.api.setServerSideDatasource(dataSource)
  }, [])

  const onFilterChanged = () => {
    if (gridRef.current) {
      const filterModel = gridRef.current.api.getFilterModel()
      const formFilters = {}
      if (filterModel.trade_date) {
        const { trade_date_start, trade_date_end } = filterModel.trade_date
        if (!trade_date_start && !trade_date_end) {
          formFilters.trade_date_start = ''
          formFilters.trade_date_end = ''
        } else {
          formFilters.trade_date_start = dayjs(trade_date_start).format('YYYY-MM-DD')
          formFilters.trade_date_end = dayjs(trade_date_end).format('YYYY-MM-DD')
        }
      }
      if (filterModel.value_date) {
        const { value_date_start, value_date_end } = filterModel.value_date
        if (!value_date_start && !value_date_end) {
          formFilters.value_date_start = ''
          formFilters.value_date_end = ''
        } else {
          formFilters.value_date_start = dayjs(value_date_start).format('YYYY-MM-DD')
          formFilters.value_date_end = dayjs(value_date_end).format('YYYY-MM-DD')
        }
      }
      if ('ag-Grid-AutoColumn' in filterModel && 'id' in filterModel['ag-Grid-AutoColumn']) {
        formFilters.id = filterModel['ag-Grid-AutoColumn'].id
      }
      if ('client' in filterModel) {
        formFilters.clients = filterModel.client
      }
      if ('market_maker' in filterModel) {
        formFilters.market_makers = filterModel.market_maker
      }
      if ('makor_prime_broker' in filterModel) {
        formFilters.makor_prime_broker = filterModel.makor_prime_broker
      }
      if ('symbol' in filterModel) {
        formFilters.symbols = filterModel.symbol
      }
      if ('prime_broker' in filterModel) {
        formFilters.makor_prime_broker = filterModel.prime_broker
      }
      if ('origin' in filterModel) {
        formFilters.origin = filterModel.origin
      }
      if ('type' in filterModel) {
        formFilters.types = filterModel.type
      }
      if ('client_quantity' in filterModel) {
        formFilters.client_quantity = Number(filterModel.client_quantity.client_quantity)
      }
      if ('client_price' in filterModel) {
        formFilters.client_price = Number(filterModel.client_price.client_price)
      }
      if ('market_maker_quantity' in filterModel) {
        formFilters.market_maker_quantity = Number(
          filterModel.market_maker_quantity.market_maker_quantity
        )
      }
      if ('market_maker_price' in filterModel) {
        formFilters.market_maker_price = Number(filterModel.market_maker_price.market_maker_price)
      }
      if ('far_price' in filterModel) {
        formFilters.far_price = Number(filterModel.far_price.far_price)
      }
      if ('far_leg_quantity' in filterModel) {
        formFilters.far_leg_quantity = Number(filterModel.far_leg_quantity.far_leg_quantity)
      }
      if ('far_value_date' in filterModel) {
        formFilters.far_value_date = filterModel.far_value_date.far_value_date
      }
      if ('expiry' in filterModel) {
        formFilters.expiry = filterModel.expiry.expiry
      }
      if ('lower_barrier' in filterModel) {
        formFilters.lower_barrier = Number(filterModel.lower_barrier.lower_barrier)
      }
      if ('barrier' in filterModel) {
        formFilters.barrier = Number(filterModel.barrier.barrier)
      }
      if ('barrier_direction' in filterModel) {
        formFilters.barrier_directions = filterModel.barrier_direction
      }
      if ('upper_barrier' in filterModel) {
        formFilters.upper_barrier = Number(filterModel.upper_barrier.upper_barrier)
      }
      if ('premium_amount' in filterModel) {
        formFilters.premium_amount = Number(filterModel.premium_amount.premium_amount)
      }
      if ('premium_date' in filterModel) {
        formFilters.premium_date = filterModel.premium_date.premium_date
      }
      if ('fix_source_date' in filterModel) {
        formFilters.fix_source_date = filterModel.fix_source_date.fix_source_date
      }
      if ('fixing_source' in filterModel) {
        formFilters.fixing_source = filterModel.fixing_source
      }
      if ('window_start' in filterModel) {
        formFilters.window_start = filterModel.window_start.window_start
      }
      if ('window_end' in filterModel) {
        formFilters.window_end = filterModel.window_end.window_end
      }
      if ('payout_currency' in filterModel) {
        formFilters.payout_currency = filterModel.payout_currency
      }
      if ('premium_currency' in filterModel) {
        formFilters.premium_currency = filterModel.premium_currency
      }
      if ('option_exercise_style' in filterModel) {
        formFilters.option_exercise_style = filterModel.option_exercise_style
      }
      if ('timing' in filterModel) {
        formFilters.timing = filterModel.timing
      }
      if ('trader' in filterModel) {
        formFilters.traders = filterModel.trader
      }
      if ('payout_amount' in filterModel) {
        formFilters.payout_amount = Number(filterModel.payout_amount.payout_amount)
      }
      if ('note' in filterModel) {
        formFilters.note = filterModel.note.note
      }
      if (filters.status_warning_and_union) {
        formFilters.status_warning_and_union = filters.status_warning_and_union
      }
      if (filters.search) {
        formFilters.search = filters.search
      }
      setFilters({ ...filters, ...formFilters })
      cleanCheckBoxState()
      setPage(1)
      cleanEmptyField(formFilters)
      skeltonLoader()
      const request = { type: 'get_trade_blotter', data: formFilters }
      webSocketWorkerEvent.sendEvent(request)
    }
  }

  const onRowGroupOpened = useCallback(params => {
    if (params.node.expanded) {
      setExpandsRow(expand => expand + 1)
    } else {
      setExpandsRow(expand => expand - 1)
    }
  }, [])

  const onRowDoubleClicked = useCallback(params => {
    if (Array.isArray(params.data.children) && params.node.expanded) {
      params.node.setExpanded(false)
    } else if (Array.isArray(params.data.children) && !params.node.expanded) {
      params.node.setExpanded(true)
    }
  }, [])

  const onRowClicked = useCallback(
    params => {
      if (params.data.isSkelton) {
        return
      }

      const disabledCondition =
        (Array.isArray(params.data.children) &&
          params.data.status === TRADE_BLOTTER_STATUS.DELETE) ||
        params.data.is_delete === 1
      if (disabledCondition) {
        return
      }
      const id = Number(params.data.id)
      // if deal
      if (Array.isArray(params.data.children)) {
        if (params.data.allocation_status === TRADE_BLOTTER_STATUS.UNALLOCATED) {
          if (id in unAllocatedDeals) {
            const copyAllUnAllocatedDeals = JSON.parse(JSON.stringify(unAllocatedDeals))
            delete copyAllUnAllocatedDeals[id]
            setSelected(selected - 1)
            setUnAllocatedDeals(copyAllUnAllocatedDeals)
          } else if (!(id in unAllocatedDeals)) {
            const copyAllUnallocatedDeals = JSON.parse(JSON.stringify(unAllocatedDeals))
            copyAllUnallocatedDeals[id] = params.data
            setSelected(selected + 1)
            setUnAllocatedDeals(copyAllUnallocatedDeals)
          }
        }
        if (id in dealsGroup) {
          const copyDealsGroup = JSON.parse(JSON.stringify(dealsGroup))
          const copyDealsGiveUpGroup = JSON.parse(JSON.stringify(dealsGiveUpGroup))
          const copyDealsNotSentToPb = JSON.parse(JSON.stringify(dealsNotSentToPb))

          delete copyDealsGroup[id]
          if (copyDealsGiveUpGroup[id]) {
            delete copyDealsGiveUpGroup[id]
            setDealsGiveUpGroup(copyDealsGiveUpGroup)
          }
          if (copyDealsNotSentToPb[id]) {
            delete copyDealsNotSentToPb[id]
            setDealsNotSentToPb(copyDealsNotSentToPb)
          }
          setSelectedAllDeal({
            ...selectedAllDeal,
            status: false,
            signDeals: selectedAllDeal.signDeals - 1
          })
          setSelected(selected - 1)
          setDealsGroup(copyDealsGroup)
        } else if (!(id in dealsGroup)) {
          const copyDealsGroup = JSON.parse(JSON.stringify(dealsGroup))
          const copyDealsGiveUpGroup = JSON.parse(JSON.stringify(dealsGiveUpGroup))
          const copyDealsNotSentToPb = JSON.parse(JSON.stringify(dealsNotSentToPb))

          copyDealsGroup[id] = params.data

          const status =
            selectedAllDeal.signDeals + 1 === selectedAllDeal.maxDeals &&
            selectedAllDeal.signDeals + 1 === selected + 1
              ? true
              : false

          setSelectedAllDeal({
            ...selectedAllDeal,
            status,
            signDeals: selectedAllDeal.signDeals + 1
          })
          setSelected(selected + 1)
          if (params.data.staging_status === STAGING_STATUS.PENDING) {
            copyDealsGiveUpGroup[id] = params.data
            setDealsGiveUpGroup(copyDealsGiveUpGroup)
          }
          setDealsGroup(copyDealsGroup)
          if (params.data.sent_to_pb === 0) {
            copyDealsNotSentToPb[id] = params.data
            setDealsNotSentToPb(copyDealsNotSentToPb)
          }
        }
      }
      // if trade
      if (!Array.isArray(params.data.children)) {
        if (
          params.data.deal_id === null &&
          params.data.status !== TRADE_BLOTTER_STATUS.CONVERSION
        ) {
          if (id in tradesGroup) {
            const copyTradesGroup = JSON.parse(JSON.stringify(tradesGroup))
            delete copyTradesGroup[id]
            setSelected(selected - 1)
            setTradesGroup(copyTradesGroup)
          } else if (!(id in tradesGroup)) {
            const copyTradesGroup = JSON.parse(JSON.stringify(tradesGroup))
            copyTradesGroup[id] = params.data
            setSelected(selected + 1)
            setTradesGroup(copyTradesGroup)
          }
        } else if (
          params.data.status === TRADE_BLOTTER_STATUS.CONVERSION &&
          params.data.staging_status === TRADE_BLOTTER_STATUS.PENDING
        ) {
          const copyTradesGiveUpGroup = JSON.parse(JSON.stringify(tradesGiveUp))
          if (!(id in tradesGiveUp)) {
            setSelected(selected + 1)
            copyTradesGiveUpGroup[id] = params.data
          } else if (id in tradesGiveUp) {
            delete copyTradesGiveUpGroup[id]
            setSelected(selected - 1)
          }
          setTradesGiveUp(copyTradesGiveUpGroup)
        } else if (
          params.data.status === TRADE_BLOTTER_STATUS.CONVERSION &&
          params.data.staging_status === null
        ) {
          const copyTradesConversionGroup = JSON.parse(JSON.stringify(tradesConversion))
          if (!(id in tradesConversion)) {
            setSelected(selected + 1)
            copyTradesConversionGroup[id] = params.data
          } else if (id in tradesConversion) {
            setSelected(selected - 1)
            delete copyTradesConversionGroup[id]
          }

          setTradesConversion(copyTradesConversionGroup)
        }
        // trade part of a deal
        else if (params.data.deal_id !== null) {
          if (id in dealTradesGroup) {
            const copyDealTradesGroup = JSON.parse(JSON.stringify(dealTradesGroup))
            delete copyDealTradesGroup[id]
            setSelected(selected - 1)
            setDealTradesGroup(copyDealTradesGroup)
          } else if (!(id in dealTradesGroup)) {
            const copyDealTradesGroup = JSON.parse(JSON.stringify(dealTradesGroup))
            copyDealTradesGroup[id] = params.data
            setSelected(selected + 1)
            setDealTradesGroup(copyDealTradesGroup)
          }
        }
      }
      //if trade inside deal
    },
    [
      tradesGroup,
      dealsGroup,
      selected,
      selectedAllDeal,
      dealsGiveUpGroup,
      dealsNotSentToPb,
      tradesGiveUp,
      tradesConversion
    ]
  )

  const onSortChange = useCallback(
    params => {
      const colState = params.columnApi.getColumnState()
      const sortedCols = colState.filter(c => c.sort)

      let formFilters

      if (sortedCols.length === 0) {
        // Reset sort filters when user clears sorting
        formFilters = { ...filters, order: '', column_order: '' }
      } else {
        const { sort, colId } = sortedCols[0]
        formFilters = { ...filters, order: sort.toUpperCase(), column_order: colId }
      }

      setFilters(formFilters)
      cleanEmptyField(formFilters)
      skeltonLoader()

      webSocketWorkerEvent.sendEvent({
        type: 'get_trade_blotter',
        data: { ...formFilters }
      })
    },
    [filters] // ✅ keep dependency clean
  )

  const getRowStyle = useCallback(
    params => {
      if (params?.data) {
        if (
          params.data.status === TRADE_BLOTTER_STATUS.DELETE ||
          (params.data.is_delete && params.data.status === TRADE_BLOTTER_STATUS.CONVERSION)
        ) {
          return { background: '#4D1A1A' }
        }
        if (params.data.staging_status === TRADE_BLOTTER_STATUS.PENDING) {
          return { background: '#2A313D' }
        }
        if (params.data.status === TRADE_BLOTTER_STATUS.CONVERSION) {
          return { background: '#39394E' }
        }
        if (params.data.allocation_status === TRADE_BLOTTER_STATUS.UNALLOCATED) {
          return {
            background: '#392C2D'
          }
        }
        if (
          [
            TRADE_BLOTTER_STATUS.WARNING_QUANTITY,
            TRADE_BLOTTER_STATUS.WARNING_EXPIRY,
            TRADE_BLOTTER_STATUS.WARNING_STRIKE,
            TRADE_BLOTTER_STATUS.WARNING_PUT_CALL,
            TRADE_BLOTTER_STATUS.WARNING_CUT
          ].includes(params.data.status) ||
          params.data.staging_status === TRADE_BLOTTER_STATUS.STAGED
        ) {
          return {
            background: '#242432'
          }
        }
        if (params.data.status === TRADE_BLOTTER_STATUS.NEW) {
          return {
            background: '#30F0D626',
            animation: 'fadeOut ease-out 3s forwards'
          }
        }
        if (params.data.status === TRADE_BLOTTER_STATUS.UNION || params.data.deal_id === null) {
          return {
            background: '#3a2f15',
            borderTop: '1px solid #504832',
            borderBottom: '1px solid #504832'
          }
        }
        if (
          !isNaN(params.data.inside_deal) &&
          params?.node?.parent?.data?.children.at(-1).id === params.data.id
        ) {
          return { background: '#323235', borderBottom: '1px solid #707079' }
        }
        if (!isNaN(params.data.inside_deal)) {
          return { background: '#323235', border: 'none' }
        }
      }
    },
    [tradeBlotterResponse]
  )

  const handelModalDealReportStatus = deal => {
    const { id: dealId, children } = deal
    let tradesId = [],
      makorPrimeBroker
    if (children.length) {
      tradesId = children.map(({ id }) => String(id))
      makorPrimeBroker = children.reduce((prev, { makor_prime_broker }) => {
        if (!prev.includes(makor_prime_broker)) {
          prev.concat(`,${makor_prime_broker}`)
        }
        return prev
      }, children[0].makor_prime_broker)
    }

    dispatch(
      setModal({
        type: MODAL_TYPE.DEAL_REPORT_STATUS,
        title: MODAL_TITLE.DEAL_REPORT_STATUS.concat(` ${dealId}`),
        data: { dealId: dealId, tradesId: tradesId, makorPrimeBroker },
        isOpen: true
      })
    )
  }

  const handelModalConversionTradeReportStatus = trade => {
    const { id: tradeId, makor_prime_broker } = trade
    let tradesId = [tradeId],
      makorPrimeBroker

    makorPrimeBroker = makor_prime_broker
    dispatch(
      setModal({
        type: MODAL_TYPE.DEAL_REPORT_STATUS,
        title: MODAL_TITLE.CONVERSION_TRADE_REPORT_STATUS.concat(` ${tradeId}`),
        data: { dealId: tradeId, tradesId, makorPrimeBroker, is_conversion: true },
        isOpen: true
      })
    )
  }

  const getContextMenuItems = useCallback(params => {
    const handelCsvDeal = async (preferTitle, dealId, trades, isConversion) => {
      const body = {
        deal_id: dealId,
        trade_ids: trades
      }

      let options1 = { headers: { Authorization: token } }
      let options2 = {}
      const url = `${process.env.REACT_APP_SERVER_URL}${leToolRoutes.getFileNames}`
      try {
        if (isConversion) {
          options1 = { headers: { Authorization: token }, params: { conversion_trade: true } }
          options2 = { is_conversion: true }
        }
        const response = await axios.post(url, body, options1)
        const dealFilenames = response.data.filenames
        const title = dealFilenames.length === 1 ? dealFilenames[0] : preferTitle

        await downlandExcelTrades(
          dispatch,
          token,
          dealId,
          options2,
          title,
          routes.dealReportTradeReportCsv
        )

        return true
      } catch (error) {
        dispatch(
          handelNotifications({
            id: Date.now(),
            type: 'error',
            message: 'please try again'
          })
        )
      }
    }

    const isDeal = () => Array.isArray(params.node.data.children)

    const disabledDownload =
      isDeal() &&
      ![STAGING_STATUS.LIVE, STAGING_STATUS.PENDING].includes(params.node.data.staging_status)

    const showTrade =
      params.node && params.node.data.deal_id === null && params.node.data.lucera_trade_id !== null

    const showCollapse = params.node && ![undefined, null].includes(params.node.data.deal_id)

    const showConversionTrade =
      params.node && params.node.data.status === TRADE_BLOTTER_STATUS.CONVERSION
    if (showConversionTrade) {
      return [
        {
          ...{
            menuItem: () => (
              <MenuItem
                name={'Download Trade'}
                onMenuClick={async () => {
                  const tradeId = params.node.data.id
                  const title = `makor_fxer_${Number(tradeId)}`
                  const trades = [params.node.data.id]
                  await handelCsvDeal(title, tradeId, trades, true)
                }}
                dealId={params.node.id}
                icon={<DownloadComponentStyle />}
                disabled={disabledDownload}
              />
            )
          }
        },
        {
          ...{
            menuItem: () => (
              <MenuItem
                name={'Status'}
                onMenuClick={() => handelModalConversionTradeReportStatus(params.node.data)}
                icon={<InfoDealStatusComponentStyle />}
                disabled={disabledDownload}
              />
            )
          }
        }
      ]
    }

    if (showCollapse) {
      return [
        {
          ...{
            menuItem: () => (
              <MenuItem
                name={'Download Deal'}
                onMenuClick={async () => {
                  const dealId = params.node.data.deal_id
                  const title = `makor_fxer_${Number(dealId)}`
                  const trades = params.node.parent.data.children.map(({ id }) => Number(id))
                  await handelCsvDeal(title, dealId, trades)
                }}
                dealId={params.node.data.deal_id}
                icon={<DownloadComponentStyle />}
                disabled={disabledDownload}
              />
            )
          }
        }
      ]
    }

    if (showTrade) {
      return [
        {
          ...{
            menuItem: () => (
              <MenuItem
                name={'Copy Trade'}
                onMenuClick={() => copyId(dispatch, params.node.data.lucera_trade_id, 'trade')}
                icon={<CopyComponentStyle />}
                disabled={false}
              />
            )
          }
        }
      ]
    }

    const showDownload = params.node && isDeal()

    if (!showDownload) {
      return false
    }

    const luceraTradesId = () => {
      if (isDeal()) {
        return Array.from(
          new Set(params.node.data.children.map(({ lucera_trade_id }) => lucera_trade_id))
        )
      } else {
        return params.node.data.lucera_deal_id
      }
    }
    if (showDownload) {
      return [
        {
          ...(showDownload
            ? {
                menuItem: () => (
                  <MenuItem
                    name={'Download Deal Report'}
                    onMenuClick={() => {
                      const title = `makor_fxer_${Number(params.node.data.id)}`
                      const dealId = Number(params.node.data.id)
                      const trades = params.node.data.children.map(({ id }) => Number(id))
                      handelCsvDeal(title, dealId, trades)
                    }}
                    dealId={Number(params.node.data.id)}
                    disabled={disabledDownload}
                    icon={<DownloadComponentStyle />}
                  />
                )
              }
            : [])
        },
        {
          ...{
            menuItem: () => (
              <MenuItem
                name={'Copy Deal'}
                onMenuClick={() => copyId(dispatch, luceraTradesId().join(','))}
                icon={<CopyComponentStyle />}
                disabled={
                  (isDeal() && !params.node.data.lucera_deal) ||
                  (params.node.data.deal_id === null && !params.node.data.lucera_deal_id)
                }
              />
            )
          }
        },
        {
          ...{
            menuItem: () => (
              <MenuItem
                name={'Status'}
                onMenuClick={() => handelModalDealReportStatus(params.node.data)}
                icon={<InfoDealStatusComponentStyle />}
                disabled={disabledDownload}
              />
            )
          }
        }
      ]
    }
  }, [])

  const onBodyScroll = useCallback(
    params => {
      gridScrollHight.current.top = params.top

      if (
        tradeBlotterPendingAgGrid.current.length > 0 &&
        gridScrollHight.current.top < 200 &&
        lock === false
      ) {
        setLock(() => true)

        const insertions = [] // {item, index}
        for (const deal of tradeBlotterPendingAgGrid.current) {
          const t = new Date(deal.trade_date).getTime()
          // find index where existing trade_date < deal.trade_date (meaning deal goes before it)
          let idx = tradeBlotterDataAgGrid.current.findIndex(
            r => new Date(r.trade_date).getTime() < t
          )
          if (idx === -1) idx = tradeBlotterDataAgGrid.current.length // append to end
          insertions.push({ item: deal, index: idx })
          // also insert locally so subsequent indices consider prior inserts
          tradeBlotterDataAgGrid.current.splice(idx, 0, deal)
        }
        tradeBlotterPendingAgGrid.current = []
        // Now apply transactions in descending index order to avoid shift problems
        insertions
          .sort((a, b) => b.index - a.index)
          .forEach(ins => {
            gridRef.current.api.applyServerSideTransactionAsync(
              { add: [ins.item], addIndex: ins.index },
              result => {
                console.log('Async transaction result:', result)
                console.log(
                  'Added',
                  tradeBlotterPendingAgGrid.current.length,
                  'new deal(s) at',
                  currentDateTime
                )
              }
            )
          })
        setBloombergRefresh(prev => prev + 1)
        setLock(() => false)
      }
    },
    [gridScrollHight, lock, bloombergRefresh]
  )

  // Function to filter and return only the requested rows
  const getRows = useCallback(params => {
    const { groupKeys } = params.request

    // Recursive function to fetch data based on the requested level
    const findMatchingRows = (groupKeys, data) => {
      let currentData = data // Start at the top level

      for (let key of groupKeys) {
        // Find the matching parent node
        const matchingNode = currentData.find(node => node.id == key)

        if (!matchingNode) {
          return [] // No matching row found
        }

        // If the node has children, move deeper; otherwise, stop
        if (matchingNode.children) {
          currentData = matchingNode.children
        } else {
          return [matchingNode] // If no children, return the found node as a row
        }
      }
      return currentData // Return the final level of data
    }

    const filteredData = findMatchingRows(groupKeys, tradeBlotterDataAgGrid.current)

    setTimeout(() => {
      params.success({ rowData: filteredData, rowCount: filteredData.length })
    }, 100)
  }, [])

  const isServerSideGroup = useCallback(data => !!data.children, [tradeBlotterResponse])

  const getServerSideGroupKey = useCallback(data => String(data.id), [tradeBlotterResponse])

  const onGridReady = useCallback(
    params => {
      //   // Only set data source if not already set
      const dataSource = { getRows }
      params.api.setServerSideDatasource(dataSource)
      if (gridRef.current) {
        const orders = JSON.parse(localStorage.getItem('columnOrder'))
        if (Array.isArray(orders) && orders.length) {
          orders.map(c => {
            c.sort = null
            return c
          })
          gridRef.current.columnApi.applyColumnState({ state: orders, applyOrder: true })
        }
      }
    },
    [tradeBlotterResponse.data]
  )

  const onFirstDataRendered = useCallback(() => {
    if (gridRef.current) {
      const allCols = gridRef.current.columnApi.getAllGridColumns().map(col => col.getColId())
      const resize = localStorage.getItem('resized')
      if (resize !== 'true') {
        gridRef.current.columnApi.autoSizeColumns(allCols, false) // include header
      }
    }
  }, [])

  const onColumnMoved = params => {
    const columnState = params.columnApi.getColumnState()
    localStorage.setItem('columnOrder', JSON.stringify(columnState))
  }

  const onColumnResized = params => {
    onColumnMoved(params)
    localStorage.setItem('resized', 'true')
  }

  return {
    onGridReady,
    onRowClicked,
    onRowDoubleClicked,
    onBodyScroll,
    onFilterChanged,
    getRowId,
    getContextMenuItems,
    getRowStyle,
    onRowGroupOpened,
    getRows,
    isServerSideGroup,
    getServerSideGroupKey,
    onColumnMoved,
    onFirstDataRendered,
    onColumnResized,
    onSortChange,
    skeltonLoader
  }
}

export default useTradeBlotterAgGridSetting
